import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Scroller from "../components/scroller"
import PortfolioModal from "../components/portfolio/modal"
import PortfolioCarousel from "../components/portfolio/carousel"
// import { Form, Button } from "react-bootstrap"
import { Formik, Field } from "formik"
import RegularField from "../components/regularField"
import * as Yup from "yup"
import Preloader from "../components/preloader"

import Pomiar from "../images/about/pomiar.svg"
import Demontaz from "../images/about/demontaz.svg"
import Montaz from "../images/about/montaz.svg"
import Obrobka from "../images/about/obrobka.svg"
import Serwis from "../images/about/serwis.svg"

import Okna from "../images/offer/Okna.svg"
import Bramy from "../images/offer/Bramy.svg"
import Drzwi from "../images/offer/Drzwi.svg"
import Markizy from "../images/offer/Markizy.svg"
import Rolety from "../images/offer/Rolety.svg"
import SmartHome from "../images/offer/smartHome.svg"
import facebookIcon from "../images/facebookIcon.svg"

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    Scroller.handleAnchorScroll = Scroller.handleAnchorScroll.bind(this)
    this.state = {
      modalShow: false,
      modalCurrent: 0,
      preloaderShow: false,
      popupSuccess: false,
      isLeaveAnimation: false,
    }
    this.handlePortfolioClick = this.handlePortfolioClick.bind(this)
    this.setModal = this.setModal.bind(this)
  }

  // componentDidMount() {
  //   alert(`Wysokość: ${window.innerHeight}px \nSzerokość: ${window.innerWidth}px`)
  // }

  handlePortfolioClick(index, e) {
    e.preventDefault()
    this.setModal(true, index)
  }

  setModal(isShown, current) {
    this.setState({
      modalShow: isShown,
      modalCurrent: current,
    })
  }
  setPreloader() {
    this.setState({ preloaderShow: !this.state.preloaderShow })
  }

  closePopup = () => {
    this.setState({ isLeaveAnimation: true }, () => {
      setTimeout(() => {
        this.setState({ isLeaveAnimation: false, popupSuccess: false })
      }, 180)
    })
  }

  render() {
    console.log(this.props.data)
    const formEl = React.createRef()
    const ContactFormSchema = Yup.object().shape({
      // Imię: Yup.string().required("Pole wymagane"),
      // Nazwisko: Yup.string().required("Pole wymagane"),
      Miejscowość: Yup.string().required("Pole wymagane"),
      Email: Yup.string()
        .email("Niepoprawny email")
        .required("Pole wymagane"),
      Tytuł: Yup.string().required("Pole wymagane"),
      Treść: Yup.string().required("Pole wymagane"),
    })

    console.log(this.props.data)

    return (
      <Layout popupSuccess={this.state.popupSuccess} isLeaveAnimation={this.state.isLeaveAnimation} closePopup={this.closePopup}>
        {this.state.preloaderShow && <Preloader />}
        {/* {this.state.popupSuccess && (
          <div className="confirmation-popup" onClick={this.closePopup}>
            <div className={`confirmation-popup__inner ${this.state.isLeaveAnimation ? "confirmation-popup__inner--hidePopup" : ""}`} onClick={this.handleChildClick}>
              <div className="confirmation-popup__content">
                <h2>Czy na pewno chcesz usunąć nagranie?</h2>
                <h6>Wykonanie akcji spowoduje trwałe usunięcie nagrania</h6>
                <div className="confirmation-popup__buttons">
                  <button className={`btn btn--default-old`} onClick={this.closePopup}>
                    Super!
                  </button>
                </div>
              </div>
            </div>
          </div>
        )} */}
        <SEO title="Home" bodyClass={this.state.popupSuccess} />
        <section className="page-section" id="about">
          {/* <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h2 className="text-white mt-0">Mamy wszystko czego potrzebujesz!</h2>
                <hr className="divider light my-4" />
                <p className="text-white-50 mb-5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pretium, libero at pellentesque sodales, diam enim finibus sapien, id consequat felis lectus sit amet nisl. Nullam tempus volutpat augue, at scelerisque diam ultrices
                  non. Sed nec risus quis lacus pellentesque bibendum eget a lacus. Fusce interdum neque sit amet elit commodo!
                </p>
                <a className="btn btn-light btn-xl js-scroll-trigger" href="#services" onClick={Scroller.handleAnchorScroll}>
                  Nasza oferta
                </a>
              </div>
            </div>
          </div> */}
          <div className="about-us-motivation">
            <div className="about-us-content">
              <h2 className="text-white mt-0">z nami wyposażysz dom w niezbędne artykuły</h2>
              <hr className="divider light my-4" />
              <p className="mb-5">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis
                nisl ut aliquip ex ea commodo consequat.
              </p>
            </div>
          </div>
          <div className="about-us-offer">
            <div className="about-us-item">
              <div className="about-us-icon">
                <img src={Pomiar} alt="Pomiar" />
              </div>
              <div className="about-us-description">
                <h2>Pomiar</h2>
                <p>Zapewniamy państwu bezpłatny pomiar dla wszystkich oferowanych produktów.</p>
              </div>
            </div>
            <div className="about-us-item">
              <div className="about-us-icon">
                <img src={Demontaz} alt="Demontaż" />
              </div>
              <div className="about-us-description">
                <h2>Demontaż</h2>
                <p>Oferujemy przygotowanie otworów do zamontowania zamówienia</p>
              </div>
            </div>
            <div className="about-us-item">
              <div className="about-us-icon">
                <img src={Montaz} alt="Montaż" />
              </div>
              <div className="about-us-description">
                <h2>Montaż</h2>
                <p>Gwarantujemy profesjonalny montaż zakupionych produktów w naszym salonie</p>
              </div>
            </div>
            <div className="about-us-item">
              <div className="about-us-icon">
                <img src={Obrobka} alt="Obróbka" />
              </div>
              <div className="about-us-description">
                <h2>Obróbka</h2>
                <p>Dbamy o pozostawienie przestrzeni w estetycznym porządku</p>
              </div>
            </div>
            <div className="about-us-item">
              <div className="about-us-icon">
                <img src={Serwis} alt="Serwis" />
              </div>
              <div className="about-us-description">
                <h2>Serwis</h2>
                <p>Zapewniamy usługi serwisowe zakupionych produktów do czasu trwania okresu gwarancji producenta</p>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section mb-5" id="offer">
          <div className="container">
            <h2 className="text-center mt-0">Oferta</h2>
            <hr className="divider mb-4 mt-2" />
            <p>Wiemy, że informacja o współpracy z producentami to za mało, dlatego zachęcamy do odwiedzenia nas w salonie i poznania szczegółów oferowanych produktów.</p>
            <div className="row">
              <div className="col-lg-4 col-md-6 text-center mb-5">
                <div className="offer-item">
                  <img className="offer-icon" src={Okna} alt="Okna" />
                  <h3 className="h4 mb-2">Okna</h3>
                  {/* <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pretium</p> */}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 text-center mb-5">
                <div className="offer-item">
                  <img className="offer-icon" src={Drzwi} alt="Drzwi" />
                  <h3 className="h4 mb-2">Drzwi</h3>
                  {/* <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pretium</p> */}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 text-center mb-5">
                <div className="offer-item">
                  <img className="offer-icon" src={Bramy} alt="Bramy" />
                  <h3 className="h4 mb-2">Bramy</h3>
                  {/* <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pretium</p> */}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 text-center mb-5">
                <div className="offer-item">
                  <img className="offer-icon" src={Rolety} alt="Rolety" />
                  <h3 className="h4 mb-2">Rolety</h3>
                  {/* <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pretium</p> */}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 text-center mb-5">
                <div className="offer-item">
                  <img className="offer-icon" src={Markizy} alt="Markizy" />
                  <h3 className="h4 mb-2">Markizy</h3>
                  {/* <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pretium</p> */}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 text-center mb-5">
                <div className="offer-item">
                  <img className="offer-icon" src={SmartHome} alt="Smart Home" />
                  <h3 className="h4 mb-2">Smart Home</h3>
                  {/* <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pretium</p> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="portfolio">
          <div className="container-fluid p-0">
            <h2 className="text-center mt-0">Realizacje</h2>
            <hr className="divider my-4 mb-5" />
            <div className="row no-gutters">
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/1.jpg" onClick={this.handlePortfolioClick.bind(this, 0)}>
                  <Img fluid={this.props.data.images.edges[0].node.childImageSharp.fluid} className="realizacja" />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">Realizacja</div>
                    <div className="project-name">Winergetic standard</div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/2.jpg" onClick={this.handlePortfolioClick.bind(this, 1)}>
                  <Img fluid={this.props.data.images.edges[1].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">Realizacja</div>
                    <div className="project-name">Winergetic standard</div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/3.jpg" onClick={this.handlePortfolioClick.bind(this, 2)}>
                  <Img fluid={this.props.data.images.edges[2].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">Realizacja</div>
                    <div className="project-name">Winergetic standard</div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="images/portfolio/fullsize/4.jpg" onClick={this.handlePortfolioClick.bind(this, 3)}>
                  <Img fluid={this.props.data.images.edges[3].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">Realizacja</div>
                    <div className="project-name">Winergetic standard</div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/5.jpg" onClick={this.handlePortfolioClick.bind(this, 4)}>
                  <Img fluid={this.props.data.images.edges[4].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">Realizacja</div>
                    <div className="project-name">Winergetic standard</div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/6.jpg" onClick={this.handlePortfolioClick.bind(this, 5)}>
                  <Img fluid={this.props.data.images.edges[5].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption p-3">
                    <div className="project-category text-white-50">Realizacja</div>
                    <div className="project-name">Winergetic standard</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="page-section bg-dark text-white">
          <div className="container text-center">
            <h2 className="mb-4">Free Download at Start Bootstrap!</h2>
            <a
              className="btn btn-light btn-xl"
              href="https://startbootstrap.com/themes/creative/"
            >
              Download Now!
            </a>
          </div>
        </section> */}

        {/* <section className="page-section" id="contact" style={{ paddingBottom: "50px" }}>
          <div className="container mb-5">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h2 className="mt-0">Skontaktuj się z nami!</h2>
                <hr className="divider my-4" />
                <p className="text-muted mb-5">Jesteś gotowy aby porozmawiać o szczegółach projektu? Zadzwoń do nas lub wyślij wiadomość mailową, a my odpowiemy najszybciej jak tylko to możliwe!</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 ml-auto text-center mb-5 mb-lg-0">
                <i className="fas fa-phone fa-2x mb-3 text-muted"></i>
                <div>84 686 55 95</div>
              </div>
              <div className="col-lg-4 mr-auto text-center">
                <i className="fas fa-envelope fa-2x mb-3 text-muted"></i>
                <a className="d-block" href="mailto:kontur@oknoplast.com.pl">
                  kontur@oknoplast.com.pl
                </a>
              </div>
            </div>
          </div>
          <div className="container text-center" style={{ marginTop: "70px" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2536.4673770737127!2d22.71302231594599!3d50.525476389836754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x472335dd8be68f33%3A0x5d7c611f5d36804c!2sKontur!5e0!3m2!1spl!2spl!4v1584211410800!5m2!1spl!2spl"
              width="100%"
              height="500"
              frameborder="0"
              style={{ boxShadow: "0px 4px 18px rgba(0,0,0,0.15)" }}
              title="Mapa"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            />
          </div>
        </section> */}
        <section className="page-section" id="contact">
          <div className="container text-center">
            <h2 className="mb-4">Formularz kontaktowy</h2>
            <Formik
              initialValues={{ Miejscowość: "", Email: "", Tytuł: "", Treść: "" }}
              validationSchema={ContactFormSchema}
              onSubmit={(values, event) => {
                var data = values

                var xhr = new XMLHttpRequest()
                xhr.open("POST", "https://script.google.com/macros/s/AKfycbzBB-hDCp2Mqzda6JdrafOyFVZmsXiMd84juu_lfIe_nzUDPg/exec")
                // xhr.withCredentials = true;
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
                xhr.onreadystatechange = () => {
                  if (xhr.readyState === 4 && xhr.status === 200) {
                    // form.reset()
                    // var thankYouMessage = form.querySelector(".thankyou_message")
                    // if (thankYouMessage) {
                    //   thankYouMessage.style.display = "block"
                    // }
                    event.resetForm()
                    this.setPreloader()
                    this.setState({ popupSuccess: true })
                    setTimeout(() => {
                      this.closePopup()
                    }, 3000)
                  }
                }
                // url encode form data for sending as post data
                var encoded = Object.keys(data)
                  .map(function(k) {
                    return encodeURIComponent(k) + "=" + encodeURIComponent(data[k])
                  })
                  .join("&")
                xhr.send(encoded)
                this.setPreloader()

                // formEl.current.submit()
              }}
            >
              {({ handleSubmit, errors, setFieldValue }) => (
                <form onSubmit={handleSubmit} id="gform" className="add-customer__form gform" ref={formEl} action="https://script.google.com/macros/s/AKfycbzBB-hDCp2Mqzda6JdrafOyFVZmsXiMd84juu_lfIe_nzUDPg/exec" method="POST">
                  {/* <Field name="Imię" type="text" wrapperClassName="default" placeholder="Wpisz imię" label="Imię" component={RegularField} errors={errors} /> */}
                  {/* <Field name="Nazwisko" type="text" wrapperClassName="default" placeholder="Wpisz nazwisko" label="Nazwisko" component={RegularField} errors={errors} /> */}
                  <div className="row">
                    <Field name="Miejscowość" type="text" wrapperClassName="default col-lg-6" placeholder="Wpisz miejscowość budowy" label="Miejscowość budowy" component={RegularField} errors={errors} />
                    <Field name="Email" type="email" wrapperClassName="default col-lg-6" placeholder="Wpisz adres email" label="Email" component={RegularField} errors={errors} />
                  </div>
                  <Field name="Tytuł" type="text" wrapperClassName="default" placeholder="Wpisz tytuł wiadomości" label="Tytuł" component={RegularField} errors={errors} />
                  <Field name="Treść" type="textarea" wrapperClassName="default" placeholder="Napisz czego potrzebujesz" label="Treść wiadomości" component={RegularField} errors={errors} />
                  {/* <p className="login__forget-password">Zapomniałeś hasła?</p> */}
                  <button className="btn btn-primary btn-xl mt-4" type="submit">
                    Wyślij wiadomość
                  </button>
                </form>
              )}
            </Formik>
          </div>
        </section>
        {/* <div className="container text-center" style={{ marginTop: "70px" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2536.4673770737127!2d22.71302231594599!3d50.525476389836754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x472335dd8be68f33%3A0x5d7c611f5d36804c!2sKontur!5e0!3m2!1spl!2spl!4v1584211410800!5m2!1spl!2spl"
            width="100%"
            height="500"
            frameborder=  "0"
            style={{ boxShadow: "0px 4px 18px rgba(0,0,0,0.15)" }}
            title="Mapa"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          />
        </div> */}
        <div className="page-section" id="contactData">
          <div className="contactData-info">
            <div className="contactData-container">
              <h2 className="mt-0">Skontaktuj się z nami!</h2>
              <hr className="divider my-4" />
              <p className="mb-5">Chętnie odpowiemy na Twoje pytania. Zadzwoń do nas lub wyślij wiadomość mailową, a my odpowiemy najszybciej jak tylko to możliwe.</p>
              <p className="boldInfo">
                84 686 55 95 <br /> kontur@oknoplast.com.pl
              </p>
              <p className="redInfo">
                ul. Bohaterów Monte Cassino <br /> 62 23 – 400 Biłgoraj
              </p>
              <a href="https://www.facebook.com/Kontur-Oknoplast-101419321358114/" target="_blank" className="facebookInfo" rel="noopener noreferrer">
                <img src={facebookIcon} alt="Facebook" />{" "}
                <p>
                  {" "}
                  Bądź na bierząco <br /> i odwiedź nas na facebooku{" "}
                </p>
              </a>
            </div>
          </div>
          <div className="contactData-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2536.4673770737127!2d22.71302231594599!3d50.525476389836754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x472335dd8be68f33%3A0x5d7c611f5d36804c!2sKontur!5e0!3m2!1spl!2spl!4v1584211410800!5m2!1spl!2spl"
              width="100%"
              height="500"
              frameborder="0"
              // style={{ boxShadow: "0px 4px 18px rgba(0,0,0,0.15)", height: "100%" }}
              // style={{ height: "100%" }}
              title="Mapa"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            />
          </div>
        </div>
        <PortfolioModal show={this.state.modalShow} onHide={() => this.setModal(false, 0)}>
          <PortfolioCarousel images={this.props.data.images.edges} current={this.state.modalCurrent} />
        </PortfolioModal>
      </Layout>
    )
  }
}

export const imageData = graphql`
  query {
    images: allFile(filter: { relativePath: { glob: "portfolio/fullsize/*.jpg" } }, sort: { fields: name }) {
      edges {
        node {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    realizations: allDirectory(filter: { relativePath: { glob: "portfolio/realizations" } }) {
      edges {
        node {
          name
          relativePath
          children {
            __typename
            ... on Directory {
              name
              relativePath
            }
          }
        }
      }
    }
  }
`
